// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers, headers2, WORKER_URL } from '../configs/constants';
import { normalizeHost } from '../utils/url';

const getGraphqlRequestOrigin = (origin?: string) =>
    typeof window !== 'undefined' ? window.location.origin : origin || '';

const getSsrForwardedHostHeaders = (origin?: string) => {
    if (typeof window !== 'undefined') return {};

    const normalizedOriginHost = normalizeHost(origin || '');
    if (!normalizedOriginHost) return {};

    return {
        'x-forwarded-host': normalizedOriginHost,
    };
};

// requests
//Query para pegar todos os dados da home page
export async function allDataHomePage(origin?: string, codsite?: number, url?: any,prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'site',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'site',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            site {
                fb_token_pixel
                top_10
                redes_topo
                fb_id_pixel
                ocultar_endereco
                copyright
                internacional
                url_maps
                html_rodape
                titulo_automatico
                modelo_pagina_imovel
                modelo_pesquisa_popular
                modelo_topo
                modelo_cidades
                modelo_busca
                modelo_card
                modelo_depoimento
                modelo_selection
                modelo_empresa
                modelo_blogs
                modelo_fundo
                modelo_equipe
                modelo_redes
                cards_busca
                mostrar_data_entrega
                afiliado_todo_site
                categoria_home
                caracteristicas_home
                titulo_card_1
                titulo_card_2
                titulo_card_3
                texto_card_1
                texto_card_2
                texto_card_3
                depoimento_imovel
                ver_url
                banner_imovel
                cidade_priorizada
                texto_botao_whats
                formulario_whats
                mostrar_mapa
                exibir_empreendimento
                moeda_tipo
                simulador
                ativa_logs
                casa_em_condominio
                carousel_temporada
                carousel_apartamento
                carousel_lancamentos
                exibir_cidade_bairro_no_imovel
                carousel_casa
                carousel_novidades
                titulo_c_top
                titulo_c_temporada
                titulo_c_novidades
                titulo_c_casas
                titulo_c_1
                titulo_c_2
                titulo_c_c_condominio
                titulo_c_apartamentos
                id
                modelo_novo
                ordenar_lista
                mostrar_visualizacoes
                site
                titulo
                meta_keywords
                meta_description
                url_logo
                url_icon
                url_video
                rodape
                texto_rodape
                cor1
                cor2
                cor3
                cor4
                cor5
                cor6
                cor7
                cor8
                cor9
                cor10
                cor11
                cor12
                cor13
                cor14
                cor15
                vgv_total
                total_imoveis
                total_cidades
                exibe_redes_sociais
                congelado
                qtd_fotos_bloqueios
                bloquear_fotos
                pixel_facebook_head
                link_chat_body
                link_chat_head
                tag_google_head
                tag_google_body
                google_analytics_head
                google_analytics_body
                libera_fts_aluguel
                banner_home
                carrossel_corretores
                frase_busca
                frase_busca_2
                tamanho_logo
                logo_horizontal
                navbar_transparente
                transacoes
                contador_marca
                politica_privacidade
                termos_uso
                promocao
                Dados {
                    inicio_txt_descricao
                    delegar_ao_agenciador
                    horario
                    final_txt_descricao
                    empresa
                    email1
                    email2
                    email3
                    email4
                    tel1
                    tel2
                    tel3
                    tel4
                    estado
                    cep
                    tel1_nome
                    tel2_nome
                    tel3_nome
                    tel4_nome
                    tel1_whats
                    tel2_whats
                    tel3_whats
                    tel4_whats
                    endereco
                    cidade
                    bairro
                    creci
                    youtube
                    facebook
                    twitter
                    instagram
                    Linkedin
                    threads
                    tiktok
                    inicio_txt_descricao
                    final_txt_descricao
                }
                video
                widget_youtube
                widget_instagram
                marca_dagua {
                    opacidade
                    posicao
                    ativada
                    tamanho_marca
                }
                exibir_agenciador
            }
            videos {
                url_youtube
                excluido
            }
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
            allBanners {
                id
                codsite
                exibir
                ordem
                extensao
                titulo
                url
                url_link
                message
                ativo
            }
            banner_empresa {
                linkbanner
                card_titulo
                subtitulo_1
                paragrafo_1
                subtitulo_2
                paragrafo_2
                subtitulo_3
                paragrafo_3
                corconfig
            }
            menus {
                link
                titulo
                Destino
                Disponivel
                Menu
                Rodape
                Topo
                Conteudo
            }
            cidades {
                id
                nome
                id_estado
                url_foto
            }
            tipos {
                id
                nome
            }
            redes_sociais {
                nome
                href
                imagem
                seguidores
                arroba
            }
            parceiros(mostrar_equipe: true) {
                id
                nome
                contador_atualizacao
                telefone
                telefone_2
                email
                mostrar_equipe
                descricao
                funcao {
                    id
                    nome
                }
                url_foto
                creci
                link_proprio
                instagram
                facebook
            }
            depoimentos {
                depoimento
                youtube
                cliente {
                    nome
                    foto
                }
            }
            precos_locacao {
                min
                max
            }
            precos_venda {
                min
                max
            }
            blogs {
                id
                url_foto
                autor
                titulo
                texto
                excluido
                data_cadastro
                id_cidade
                id_empreendimento
                categoria
                id_categoria
            }
            carrosseis {
                id_bairro
                id
                id_tipo
                id_categoria
                id_cidade
                id_caracteristica
                id_empreendimento
                preco_min
                preco_max
                url_red,
                titulo
                top_10
                novidades_semana
                personalizado
                exclusivos
                venda
                aluguel
                cor_fundo
                cor_degrade
                cor_font
                cor_botoes
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar os cards de busca
export async function cards_busca(origin?: string, codsite?: number, url?: any,prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'cards_busca',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'cards_busca',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            cards_busca {
                id
                nome
                url
                cor
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar os carrosseis de destaque da home
export async function carrosseis_destaque_home(
    origin?: string,
    codsite?: number,
    _url?: any,
    prodOrigin?: any
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient =
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'carrosseis_destaques',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'carrosseis_destaques',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            carrosseis_destaque {
                id
                modelo
                titulo
                subtitulo
                descricao
                cor_fonte
                foto_banner
                posicao
                cor_titulos
                cor_degrade
                cor_fundo
                codsite
                ativo
                posts {
                    id
                    texto_botao
                    id_imovel
                    url_foto
                    descricao
                    url_redirect
                    target_blank
                    id_empreendimento
                }
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar informações para o rodapé
export async function allRodapes(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(origin == codsite){
        endpoint = '/api/gql';
    }

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'allRodapes'
        },
    });

    const query = gql`
    {
        rodape {
            tipo
            cidade
            bairro
            dormitorios
            aluguel
            venda
            empreendimento
        }
    }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar todos os dados do site
export async function allDataSite(origin?: string, codsite?: number) {
    // if (!origin && typeof window === 'undefined') {
    //     origin = localStorage.getItem('dominio') || '';
    // }
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'allDataSite'
        },
    });
    const query = gql`
        {
            site {
                copyright
                internacional
                url_maps
                html_rodape
                titulo_automatico
                modelo_pagina_imovel
                modelo_topo
                modelo_cidades
                modelo_busca
                modelo_card
                modelo_depoimento
                modelo_empresa
                modelo_blogs
                modelo_pesquisa_popular
                modelo_redes
                modelo_selection
                cards_busca
                mostrar_data_entrega
                afiliado_todo_site
                categoria_home
                caracteristicas_home
                titulo_card_1
                titulo_card_2
                titulo_card_3
                texto_card_1
                texto_card_2
                texto_card_3
                ativa_logs
                redes_topo
                top_10
                depoimento_imovel
                ver_url
                banner_imovel
                cidade_priorizada
                mostrar_mapa
                texto_botao_whats
                formulario_whats
                exibir_empreendimento
                moeda_tipo
                simulador
                casa_em_condominio
                carousel_temporada
                carousel_apartamento
                carousel_lancamentos
                exibir_cidade_bairro_no_imovel
                carousel_casa
                carousel_novidades
                titulo_c_top
                titulo_c_temporada
                titulo_c_novidades
                titulo_c_casas
                titulo_c_1
                titulo_c_2
                titulo_c_c_condominio
                titulo_c_apartamentos
                id
                modelo_novo
                ordenar_lista
                mostrar_visualizacoes
                site
                titulo
                meta_keywords
                meta_description
                url_logo
                url_icon
                url_video
                rodape
                texto_rodape
                cor1
                cor2
                cor3
                cor4
                cor5
                cor6
                cor7
                cor8
                cor9
                cor10
                cor11
                cor12
                cor13
                cor14
                cor15
                vgv_total
                total_imoveis
                total_cidades
                exibe_redes_sociais
                congelado
                qtd_fotos_bloqueios
                bloquear_fotos
                pixel_facebook_head
                link_chat_body
                link_chat_head
                tag_google_head
                tag_google_body
                google_analytics_head
                google_analytics_body
                libera_fts_aluguel
                banner_home
                carrossel_corretores
                frase_busca
                frase_busca_2
                tamanho_logo
                logo_horizontal
                navbar_transparente
                transacoes
                contador_marca
                politica_privacidade
                termos_uso
                promocao
                Dados {
                    inicio_txt_descricao
                    horario
                    delegar_ao_agenciador
                    final_txt_descricao
                    empresa
                    email1
                    email2
                    email3
                    email4
                    tel1
                    tel2
                    tel3
                    tel4
                    tel1_nome
                    tel2_nome
                    tel3_nome
                    tel4_nome
                    tel1_whats
                    tel2_whats
                    tel3_whats
                    tel4_whats
                    endereco
                    cidade
                    bairro
                    creci
                    youtube
                    facebook
                    twitter
                    instagram
                    Linkedin
                    threads
                    tiktok
                    inicio_txt_descricao
                    final_txt_descricao
                }
                video
                widget_youtube
                widget_instagram
                marca_dagua {
                    opacidade
                    posicao
                    ativada
                    tamanho_marca
                }
                exibir_agenciador
            }
            cidades {
                id
                nome
                id_estado
                url_foto
            }
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
            tipos {
                id
                nome
            }
            redes_sociais {
                nome
                href
                imagem
                seguidores
                arroba
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar se o site está congelado
export async function siteCongelado(origin?: string, codsite?: number,url?: string) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = '/api/gql';

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            site {
                congelado
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
